import { render, staticRenderFns } from "./FormElementButtonPublish.vue?vue&type=template&id=6ecbcd50&scoped=true&"
import script from "./FormElementButtonPublish.vue?vue&type=script&lang=ts&"
export * from "./FormElementButtonPublish.vue?vue&type=script&lang=ts&"
import style0 from "./FormElementButtonPublish.vue?vue&type=style&index=0&id=6ecbcd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecbcd50",
  null
  
)

export default component.exports